module.exports = __webpack_public_path__ + "img/crewFamilyXmasParty4.0e58c64d.jpg";